<style>
.badge-info {
    color: #ff9f43;
    background-color: #ff9f4333;
}
.badge-success {
    color: #2eb168;
    background-color: #23b5642e;
}
.badge-danger {
    color: #dc3545;
    background-color:#da425324;
}
.badge-warning {
    color: #ffc107;
    background-color:#0dcaf033;
}
.badge-warn_info {
    color: #049bb9fc;
    background-color:#0dcaf030;
}
.badge-secondary {
    color: #6b747c;
    background-color:#6b747c80;
}
.badge {
    display: inline-block;
    padding: 0.35em 0.4em;
    font-size: 92%;
    font-weight: bold;
    line-height: 1;

    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 10px;
}
.mx-calendar-header {
    padding: 0 4px;
    height: 36px;
    line-height: 51px;
    text-align: center;
    overflow: hidden;
}

.mx-icon-last-month, .mx-icon-last-year, .mx-icon-next-month, .mx-icon-next-year {
    padding: 0 6px;
    font-size: 20px;
    line-height: 51px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.mx-panel-date td, .mx-panel-date th {
    font-size: 12px;
    width: 32px;
    height: 30px;
    padding: 0;
    overflow: hidden;
    text-align: center;
}
.nav-tabs .nav-item {
  margin-bottom: -1px;
  border: 1px solid #d2d0d0;
  background-color: #d2d0d0;
}
.nav-tabs .nav-link.active {
    color: #29363d;
    background-color: #ffffff;
    border-bottom-color: #fff;

}
.vue-treeselect__input {
    max-width: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    outline: none;
    box-sizing: content-box;
    box-shadow: none;
    background: none transparent;
    line-height: 1;
    vertical-align: middle;
    position: unset;
}

.nav-link, .navbar .dropdown-toggle {
    display: block;
    padding: 0.5rem 3rem;
}
.nav-tabs .nav-link, .nav-tabs .navbar .dropdown-toggle, .navbar .nav-tabs .dropdown-toggle {
    color: #000;
}
.nav-tabs .nav-item {
    margin-bottom: -1px;
    border: 1px solid #d2d0d0;
}
.app-header.navbar,.app-header.navbar .navbar-brand{
  background-color: #4285f4;
}
.app-header.navbar .navbar-toggler{
  color: #fff;
  border: 1px solid #fff;
  border-radius: 8px;
  margin-left: 10px;
}
.dropdown-toggle::after{
  border-top: 0.3em solid #fff;
}
.nav-dropdown-items{
  width: 200px;
}
.sidebar-fixed .main, .sidebar-fixed .app-footer{
  margin-left: 0px;
}
.nav-item a{
  color: #fff;
}
.app-header.navbar .nav-item .nav-link{
  padding-top: 15px;
}
.app-header.navbar .nav-item{
  height: 55px;
}

/* switch */
.switch {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 18px;
  left: 30px;
  top: 5px;
}

.switch input {
  display:none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #424242;
  background-color: #e4e5e6;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider.round {
  border-radius: 10px;
}

.slider.round:before {
  border-radius: 50%;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 2px;
  bottom: 2.3px;
  background-color: white;
  border: 1px solid #000;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #ff9900;
  border: 1px solid #424242;
}

input:focus + .slider {
  background-color: #fff;
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(17px);
  -ms-transform: translateX(17px);
  transform: translateX(17px);
  border: 1px solid #808080;
}

.nav-item a{
  color:#424242;
}

.app-header.navbar .nav-item .nav-link{
  padding-top: 8px;
}

.v-sidebar-menu .vsm-item{
  border-bottom: 1px dotted #b6b7b8;
}

.parent-active-item .vsm-list .active-item .router-link-exact-active{
  color: #20a8d8!important;
}
  .menu_item{
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 0px;
    display: inline-block;
    cursor: pointer;
    color: #fff;
  }
  .menu_options_sub{
    display: none;
    width: 100%;
    height: auto;
    position: absolute;
    top: 55px;
    background-image: linear-gradient(#fff,#D3D3D3);
    color:#000000;
  }

  .mlink a{
    text-decoration: none;
    color:#000000;
  }
  .mlink{
    padding-top: 4px;
    padding-bottom: 6px;
    border-bottom: 1px dotted #bdbdbd;
  }
  .linkactive{
    color:#4b8cbb!important;
  }
  tr:hover{
    background-color: transparent;
  }
  .topheadv1{
    padding-bottom: 5px;
    cursor: pointer;
    font-size: 14px;
  }
  .menu_options_mn{
    height: 100%;
    vertical-align: middle;
    line-height: 3;
    margin-left: 45px;
  }
  .menu_data{
    text-align: left;
    height: 100%;
    border: 1px solid #bdbdbd;
    font-family: Roboto, Arial, sans-serif;
    color: #424242;
    font-size: 13px;
    font-weight: 500;
  }
.table {
  width: 100%;
  height:100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.table td{
  border: none;
}
.dropdown-toggle::after{
  border-top: 0.3em solid #fff;
}
.app-header.navbar .dropdown-menu{
  top: 50px;
  max-height: 300px;
  overflow-x: hidden;
}
.app-header.navbar .navbar-brand,.app-header.navbar{
  background-color: linear-gradient(to left,#164b86 0, #8f92bf 100%);
}
.navbar-nav .nav-link.active,.navbar .navbar-nav .active.dropdown-toggle:hover{
  color: #fff!important;
}
.app-header.navbar .navbar-toggler {
  color: #fff;
  border: 1px solid #fff;
  border-radius: 8px;
  margin-left: 80px;
}
.breadcrumb ul li{
  border-bottom: none;
}
.navbar ul.navbar-nav li{
  border-bottom: none;
}
.sidebar-fixed .sidebar,
.sidebar .sidebar-nav,
.sidebar .nav {
  width: 245px;
}
.sidebar-fixed .main,
.sidebar-fixed .app-footer {
  margin-left: 245px;
}
.sidebar-hidden .sidebar{
  margin-left: -245px;
}
.custom-dropdown{
  border-bottom:none;
}
.onHover .ui.selection.dropdown>.dropdown.icon{
  color:#fff;
}
.onHover .dropdown-menu.dropdown-menu-right{
  top: -10px !important;
}
.onHover .ui.dropdown:not(.button)>.default.text{
  color: #fff;

}
.onHover .ui.search.dropdown>input.search{
  background: #20a8d8 !important;
  border: 1px solid #fff !important;
  height: 35px;
  color: #fff
}
.select>button {
    border: 1px solid #c6c6c6;
    border-radius: 4px;
    color: #555;
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    min-height: 31px;
    width: 275px;
    padding: 1px 8px 1px 8px;
    position: relative;
    text-align: center;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    white-space: normal;
    background-color: #fff;
}

.swal2-popup {
  padding-top: 0.1em !important;
  font-size: 13px;
}
.swal2-content {
    color: #000000;
    line-height: normal;
    text-align: center;
    word-wrap: break-word;
}
.swal2-title {
    position: relative;
    max-width: 100%;
    margin: 0 0 .4em;
    padding: 0;
    color: #595959;
    font-size: 1em !important;
    font-weight: 600;
    text-align: center;
    margin-top: 13px !important;
    text-transform: none;
    word-wrap: break-word;
}
.swal2-icon {
  width: 4em;
  height: 4em;
}

.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip] {
    top: 2.3em;
    left: .700em;
    width: 1.25em;
    transform: rotate(45deg);
}

.swal2-icon.swal2-success [class^=swal2-success-line][class$=long] {
    top: 1.9em;
    right: .4em;
    width: 2.35em;
    transform: rotate(-45deg);
}
.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left] {
    left: 0.85em;
    transform: rotate(45deg);
}
.swal2-icon.swal2-error [class^=swal2-x-mark-line] {
    display: block;
    position: absolute;
    top: 1.85em;
    width: 2.35em;
    height: .2500em;
    border-radius: .100em;
    background-color: #f27474;
}
.swal2-icon.swal2-success .swal2-success-fix {
    position: absolute;
    z-index: 1;
    top: .4em;
    left: 1.3em;
    width: .3500em;
    height: 4.5em;
    transform: rotate(-45deg);
}
.ui.search.dropdown>.text {
  font-size: 13px;
  padding-right: 1px;
}
.ui.dropdown, .ui.dropdown input {
    font-size: 13px;
}
.ui.selection.dropdown{
  border: 1px solid #c2cfd6 !important;
}
.ui.dropdown .menu>.item {
    font-size: 13px;
}
.form-control {
  font-size: 13px;
}

.ui.default.dropdown:not(.button)>.text, .ui.dropdown:not(.button)>.default.text {
    color: #3e515b;
}

.card-actions{
  cursor:pointer;
}
.multiselect__tags {
  font-size: 13px;
  border: 1px solid #c2cfd6;
}
.multiselect, .multiselect__input, .multiselect__single{
  font-size: 13px;
}

.vue-treeselect{
  font-size: 13px;
}
.vue-treeselect__placeholder{
  color: #3e515b;
}
.vue-treeselect__control{
  border: 1px solid #c2cfd6;
}
.vue-treeselect__menu-container{
  color: #3e515b;
}
.form-group {
    margin-bottom: 0.6rem;
}
.multiselect__input, .multiselect__single {
    position: relative;
    display: inline-block;
    min-height: 20px;
    line-height: 20px;
    border: none;
    border-radius: 5px;
    background: #fff;
    padding: 0 0 0 5px;
    width: 100%;
    transition: border .1s ease;
    box-sizing: border-box;
    margin-bottom: 8px;
    vertical-align: top;
    z-index: 1 !important;
}
.routehubname .multiselect__tags .multiselect__single {
  z-index: 0 !important;
}
.mx-input {
    position: unset;
    display: inline-block;
    width: 100%;
    height: 34px;
    padding: 6px 30px;
    padding-left: 10px;
    font-size: 14px;
    line-height: 1.4;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.centraldbconfig .multiselect.multiselect--active .multiselect__content-wrapper{
  position: unset!important;
}
</style>
<template>
<header class="app-header navbar">
  <div class="navbar-brand"></div>
  <div v-show ="header == true" align="center" id="bit00_3" @click="sidebarToggle">
    <label class="switch">
      <input type="checkbox" id="checkbox1">
      <div class="slider round" title="Toggle Menubar">
        <span class="on"></span>
        <span class="off"></span>
      </div>
    </label>
  </div>
   <b-nav is-nav-bar class="ml-auto" style="margin-right:1%;" v-show ="header == true">
    <b-nav-item-dropdown no-caret disabled>
      <template slot="button-content">
        <span style="color:#fff;cursor:default;"> <i class="fa fa-map-marker" style="font-size:22px;color:red;padding-left:10px;"></i> {{currentHubName}} </span>
      </template>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown right>
      <template slot="button-content">
          <img src="static/img/avatars/default-img.png" class="img-avatar">
          <span class="d-md-down-none" style="color: #fff !important">{{useremail}}</span>
      </template>
      <b-dropdown-item v-if="isChangeDefaultHub" @click="changedefaulthub"><i class="fa fa-map-marker"></i> Change Default Hub</b-dropdown-item>
      <b-dropdown-item v-if="isChangePassword" @click="ChangePassword"><i class="fa fa-key"></i> Change Password</b-dropdown-item>
      <b-dropdown-item @click="logout"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</header>

</template>
<script>
import CryptoJS from 'crypto-js';
import axios from 'axios';
import apiUrl from '../constants';
import {
  BasicSelect
} from 'vue-search-select';
import keycloak from "../keycloack";

export default {
  name: 'header',
  components: {
    BasicSelect
  },
  data() {
    return {
      username: '',
      useremail: '',
      header:true,
      usertype: '',
      header:true,
      logindata: [],
      navItem:[],
      userid: '',
      currentHub: '',
      currentHubName: '',
      isChangeDefaultHub:false,
      isChangePassword:false
    }
  },
  mounted() {
  if(false == this.$route.meta.requiresAuth){
  this.header =false;
  $(".v-sidebar-menu").css("display","none");
  $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","0px");
  }
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes  = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail =JSON.parse(plaintext);
    this.checkForIsChangeDefaultHub(userdetail.access);
    this.checkForIsChangePassword(userdetail.access);
    this.username = userdetail.username;
    this.useremail = userdetail.email;
    this.userid = userdetail.userid;
    this.currentHub = userdetail.hubID[0];
    this.currentHubName = userdetail.currentHubName;
    var value = 1;
    var checkbox1 = document.getElementById("checkbox1");
    checkbox1.checked = value;
    document.getElementById("checkbox1").addEventListener("change", function(element){
      if(checkbox1.checked==false){
        $(".v-sidebar-menu").css("display","none");
        $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","0px");
      }else if(checkbox1.checked==true){
        $(".v-sidebar-menu").css("display","block");
        $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","270px");
      }
    });
    this.$nextTick(() => {
      $(document).ready(function(){
        $(".menu_options_mn").on("mouseover",function(){
          $(".menu_options_sub").slideDown("slow");
        });
        $(".menu_options_sub").on("mouseleave", function(){
          $(this).slideUp("slow");
        });
        $("a").click(function(){
          $("a.linkactive").removeClass("linkactive");
          $(this).addClass("linkactive");
        });
      });
    })
  },
  methods: {
    sidebarToggle(e) {

    },
    checkForIsChangeDefaultHub(userdetail){
      this.isChangeDefaultHub = userdetail.some(el=>el.url == '/changedefaulthub');
    },
    logout(e) {
      e.preventDefault()
      keycloak.logoutWithoutTokenId()
      // localStorage.removeItem('permissiondata')
      // localStorage.removeItem('userdetail')
      // localStorage.removeItem('userToken')
      // localStorage.removeItem('isLoggedIn')
      // window.location.href = "https://stage-auth.xbees.in/realms/xpressbees/protocol/openid-connect/logout?client_id=b2bxpress-ui"
    },
     changedefaulthub() {
        this.$router.push('/changedefaulthub')
    },
      checkForIsChangePassword(userdetail){
      this.isChangePassword = userdetail.some(el=>el.url == '/changepassword');
    },
    ChangePassword(){
      this.$router.push('/changepassword')
    },
    sidebarMinimize(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    itemlink(){
       $(".menu_options_sub").slideUp("slow");
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue?68012840